import { client } from "utils";

export const getConfigCiTestCasesRequest = () => client.get("config-ci-test-cases");
